import {TableCell, TableRow} from "../../../components/table/CustomTable";
import CustomIcon from "../../../components/CustomIcon";
import CustomButton, {OutlinedButton} from "../../../components/CustomButton";
import {setManageUserModals} from "../../../redux/slices/manageUserSlice";
import {useDispatch} from "react-redux";
import {USER_STATE_INACTIVE} from "../constants";
import {getFullName} from "../../../helpers/helperFunctions";
import Status, {Tag} from "components/table/Status";
import ToggleSwitch from "components/toggleSwitch/ToggleSwitch";

export default function ManageUserTableItem({user}) {

  const dispatch = useDispatch();

  const isUserInactive = user.state === USER_STATE_INACTIVE;

  return <TableRow>
    <TableCell>
      <div className="items-center">
        {/*<ImageWrapper imageUrl={eventItem.image} imageName={eventItem.image}/>*/}
        <div className="font-medium text-base">{getFullName(user)} {(user.super_admin || user.staff) &&
          <Tag label={user.super_admin ? 'Super Admin' : 'Admin'}/>
        }</div>

        <div className="flex flex-wrap break-all link">{user.email}</div>
      </div>
    </TableCell>
    <TableCell>

      {user.email_verified ?

        <div className="flex space-x-2">
          {/*<ToggleSwitch isChecked={true} onChange={}/>*/}
          <ToggleSwitch isChecked={!isUserInactive} onChange={() => dispatch(setManageUserModals({
            modal: true,
            data: {user},
            isConfirm: true
          }))}/>
          <div className={`text-sm ${isUserInactive ? 'text-loader' : 'text-success'}`}>{user.state}</div>
          {/*<span*/}
          {/*  className={`cursor-pointer underline ${isUserInactive ? 'text-error-300' : 'text-secondary-500'}`}*/}
          {/*  onClick={() => dispatch(setManageUserModals({*/}
          {/*    modal: true,*/}
          {/*    data: {user},*/}
          {/*    isConfirm: true*/}
          {/*  }))}>{user.state}</span>*/}
        </div>
        : <div>
          <Status label={<div className="inline-flex divide-x">
            <span>Verification Pending 
            </span>
            <span
              onClick={() => dispatch(setManageUserModals({modal: true, data: {user, verify: true}, isConfirm: true}))}
              className="text-info cursor-pointer hover:text-dark font-normal ml-2 pl-2 underline">Verify Manually</span>
          </div>} className="bg-amber-100 text-warning"/>

        </div>}
    </TableCell>
    <TableCell>
      <div className="flex items-center justify-end space-x-2">
        {!user.super_admin && !user.staff &&
          <OutlinedButton
            onClick={() => dispatch(setManageUserModals({modal: true, data: user, isFeatureAdd: true}))}>
            <CustomIcon icon="settings" className="mr-1 mt-0.5"/> <span>Permissions</span>
          </OutlinedButton>}

        <CustomButton isIconButton={true}
                      onClick={() => dispatch(setManageUserModals({modal: true, data: user}))}>
          <CustomIcon icon="edit"/>
        </CustomButton>

        {/*{*/}
        {/*  isUserInactive ? <OutlinedButton isIconButton={true} onClick={() => dispatch(setManageUserModals({*/}
        {/*      modal: true,*/}
        {/*      data: {user},*/}
        {/*      isConfirm: true*/}
        {/*    }))}>*/}
        {/*      <CustomIcon icon="arrow_forward_ios"/>*/}
        {/*    </OutlinedButton>*/}
        {/*    :*/}
        {/*    <DangerButton isIconButton={true}*/}
        {/*                  onClick={() => dispatch(setManageUserModals({modal: true, data: {user}, isConfirm: true}))}>*/}
        {/*      <CustomIcon icon="delete"/>*/}
        {/*    </DangerButton>*/}
        {/*}*/}


      </div>
    </TableCell>


  </TableRow>;
}
